import React from 'react';
import Type from 'prop-types';
import { Radio, Checkbox } from "@mui/material";
import cn from 'classnames';
import styles from './ListPickerItem.module.css';

const ListPickerItem = (props) => {
  const { primary, secondary, multiple, state, primaryClassName, secondaryClassName } = props;

  const SecondaryAction = multiple ? Checkbox : Radio;

  return (
    <>
      <div className={styles.optionContent}>
        <div className={styles.optionText}>
          <div className={cn(primaryClassName, styles.primaryText)}>{primary}</div>
          {secondary && (
            <div className={cn(secondaryClassName, styles.secondaryText)}>{secondary}</div>
          )}
        </div>
      </div>
      <div className={styles.secondaryAction}>
        <SecondaryAction color="primary" edge="end" checked={state.selected} />
      </div>
    </>
  );
};

ListPickerItem.propTypes = {
  multiple: Type.bool,
  primary: Type.oneOfType([Type.node, Type.string]).isRequired,
  secondary: Type.oneOfType([Type.node, Type.string]),
  primaryClassName: Type.string,
  secondaryClassName: Type.string,
  state: Type.shape({
    selected: Type.bool.isRequired,
    inputValue: Type.string.isRequired,
  }).isRequired,
};

ListPickerItem.defaultProps = {
  secondary: null,
  multiple: false,
  primaryClassName: undefined,
  secondaryClassName: undefined,
};

export default ListPickerItem;
